import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatTabGroup } from '@angular/material';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { sentry } from 'sentry';
import { ConfirmDialogService } from '../../../../../@fuse/components/confirm-dialog/confirm-dialog.service';
import { DialogAlertComponent } from '../dialog-alert/dialog-alert.component';
import { DialogReallocateMaintenanceComponent } from '../dialog-reallocate-maintenance/dialog-reallocate-maintenance.component';
import { DialogReopenMaintenanceComponent } from '../dialog-reopen-maintenance/dialog-reopen-maintenance.component';
import { TabCommentsComponent } from './tabs/comments/tab-comments.component';
import { TabMaintenanceComponent } from './tabs/maintenance/tab-maintenance.component';
var DialogEditMaintenanceComponent = /** @class */ (function () {
    function DialogEditMaintenanceComponent(data, matDialogRef, fuseProgressBarService, authenticationService, translateService, maintenancesApi, customMessageService, matDialog, confirmDialogService, route, router) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
        this.translateService = translateService;
        this.maintenancesApi = maintenancesApi;
        this.customMessageService = customMessageService;
        this.matDialog = matDialog;
        this.confirmDialogService = confirmDialogService;
        this.route = route;
        this.router = router;
        this.isViewMode = false;
        this.isSavingMaintenance = false;
        this.isValidMaintenanceForm = false;
        this.refreshDatatable = false;
        this.tabIndex = {
            comment: 9
        };
        this.isLoading = new EventEmitter();
        this.destroy$ = new Subject();
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
        this.hasPendenciesViewPermission = this.authenticationService.hasPermission('pendencies-list');
        this.hasCreateWarrantyPermission = this.authenticationService.hasPermission('warranties-create');
        this.hasEditWarrantyPermission = this.authenticationService.hasPermission('warranties-edit');
        this.isViewMode = this.data.isViewMode;
        this.maintenance = this.data.maintenance;
        this.selectedTabName = this.data.selectedTabName;
        this.hasCreateEditWarrantyPermission = this.maintenance.status === 'new';
    }
    DialogEditMaintenanceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getPendenciesTotalCount();
        var selectedTab = this.route.snapshot.queryParams.selectedTab || this.selectedTabName;
        setTimeout(function () {
            if (selectedTab) {
                _this.switchToTab(selectedTab);
            }
        }, 600);
    };
    DialogEditMaintenanceComponent.prototype.switchToTab = function (tabName) {
        var tabIndex = this.tabGroup._tabs.toArray().findIndex(function (tab) { return tab.textLabel === tabName; });
        this.selectedTabIndex = tabIndex;
    };
    DialogEditMaintenanceComponent.prototype.ngOnDestroy = function () {
        this.matDialogRef.close(this.refreshDatatable);
        this.destroy$.next();
        this.destroy$.complete();
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: null,
            queryParamsHandling: '',
        });
    };
    DialogEditMaintenanceComponent.prototype.getPendenciesTotalCount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.maintenancesApi.getMaintenancePendenciesTotalCount(this.maintenance.id).toPromise()];
                    case 1:
                        _a.pendenciesTotalCount = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogEditMaintenanceComponent.prototype.getForm = function (form) {
        this.maintenanceForm = form;
        this.isValidMaintenanceForm = form.valid;
    };
    DialogEditMaintenanceComponent.prototype.getEquipmentsForm = function (form) {
        this.isValidMaintenanceForm = form.valid;
    };
    DialogEditMaintenanceComponent.prototype.getDeadlinesForm = function (form) {
        if (this.maintenanceForm && this.maintenance.deadlineContract) {
            this.isValidMaintenanceForm = form.valid;
            this.maintenanceForm.get('responseDeadlineViolationReason').setValue(form.get('responseDeadlineViolationReason').value);
            this.maintenanceForm.get('solutionDeadlineViolationReason').setValue(form.get('solutionDeadlineViolationReason').value);
        }
    };
    DialogEditMaintenanceComponent.prototype.toMaintenanceDeadlinesInput = function () {
        var deadlineViolationReasons = {};
        if (!this.maintenance.deadlineContract) {
            return deadlineViolationReasons;
        }
        var isResponseDeadlineLinkedByCompany = this.maintenance.deadlineContract.responseDeadlineViolationReason
            && this.maintenance.deadlineContract.responseDeadlineViolationReason.linkedBy === 'company';
        var isSolutionDeadlineLinkedByCompany = this.maintenance.deadlineContract.solutionDeadlineViolationReason
            && this.maintenance.deadlineContract.solutionDeadlineViolationReason.linkedBy === 'company';
        var isResponseDeadlineViolatedOrCompletedWithViolation = ['violated', 'completedWithViolation'].includes(this.maintenance.responseDeadlineStatus);
        var isSolutionDeadlineViolatedOrCompletedWithViolation = ['violated', 'completedWithViolation'].includes(this.maintenance.solutionDeadlineStatus);
        if (isResponseDeadlineViolatedOrCompletedWithViolation && !isResponseDeadlineLinkedByCompany) {
            var responseDeadlineViolationReason = (this.maintenanceForm.get('responseDeadlineViolationReason').value && this.maintenanceForm.get('responseDeadlineViolationReason').value.id) || null;
            deadlineViolationReasons['responseDeadlineViolationReasonId'] = responseDeadlineViolationReason;
        }
        if (isSolutionDeadlineViolatedOrCompletedWithViolation && !isSolutionDeadlineLinkedByCompany) {
            var solutionDeadlineViolationReason = (this.maintenanceForm.get('solutionDeadlineViolationReason').value && this.maintenanceForm.get('solutionDeadlineViolationReason').value.id) || null;
            deadlineViolationReasons['solutionDeadlineViolationReasonId'] = solutionDeadlineViolationReason;
        }
        return isEmpty(deadlineViolationReasons) ? {} : { deadlineViolationReasons: deadlineViolationReasons };
    };
    DialogEditMaintenanceComponent.prototype.saveMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance, maintenanceStatus, time, date, dateTime, hasNewScheduleSuggestionValue, isNewOrRequestedMaintenance, isCorporateSuggested, scheduleSuggestionsWasChanged, scheduleSuggestionsMapped, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        this.isSavingMaintenance = true;
                        maintenance = tslib_1.__assign({ status: this.maintenanceForm.get('status').value, typeId: this.maintenanceForm.get('typeId').value, message: this.maintenanceForm.get('message').value, segmentId: this.maintenanceForm.get('segment').value.id, problemId: this.maintenanceForm.get('problemId').value || null, locationId: this.maintenanceForm.get('locationId').value || null, deadlineContractId: this.maintenanceForm.get('deadlineContract').value ? this.maintenanceForm.get('deadlineContract').value.id : null, weight: Number(this.maintenanceForm.get('weight').value) || 1 }, this.toMaintenanceDeadlinesInput());
                        maintenance['companyId'] = this.maintenanceForm.get('company').value && this.maintenanceForm.get('company').value.id || null;
                        maintenance['assigneeId'] = this.maintenanceForm.get('assignee').value ? this.maintenanceForm.get('assignee').value.id : null;
                        maintenanceStatus = this.maintenanceForm.get('status').value;
                        if (maintenanceStatus !== 'new' && maintenanceStatus !== 'pending') {
                            if (this.maintenanceForm.get('scheduledDate').value) {
                                maintenance['scheduledAt'] = this.maintenanceForm.get('scheduledDate').value;
                            }
                            maintenance['scheduledTime'] = this.maintenanceForm.get('scheduledTime').value || null;
                        }
                        if (maintenanceStatus === 'done' || maintenanceStatus === 'canceled') {
                            if (this.maintenanceForm.get('closedDate').value && this.maintenanceForm.get('closedTime').value) {
                                time = this.maintenanceForm.get('closedTime').value;
                                if (time.indexOf(':') === -1) {
                                    time = time.split('');
                                    time.splice(time.length - 2, 0, ':');
                                    time = time.toString().replace(/(,)/g, '');
                                }
                                date = moment(this.maintenanceForm.get('closedDate').value).format('YYYY-MM-DD');
                                dateTime = date + "T" + time;
                                maintenance['closedAt'] = moment(dateTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                                maintenance['statusDescription'] = this.maintenanceForm.get('statusDescription').value;
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        hasNewScheduleSuggestionValue = this.maintenanceForm.get('scheduleSuggestionsStatus').value === 'newScheduleSuggestion';
                        isNewOrRequestedMaintenance = this.maintenanceForm.get('status').value === 'new' || this.maintenanceForm.get('status').value === 'requested';
                        isCorporateSuggested = this.maintenanceForm.get('scheduleSuggestionsStatus').value === 'corporateSuggested';
                        scheduleSuggestionsWasChanged = this.maintenanceForm.get('scheduleSuggestionsWasChanged') && this.maintenanceForm.get('scheduleSuggestionsWasChanged').value;
                        if (!(scheduleSuggestionsWasChanged || hasNewScheduleSuggestionValue || (isNewOrRequestedMaintenance && isCorporateSuggested))) return [3 /*break*/, 3];
                        this.maintenanceForm.get('scheduleSuggestionsStatus').setValue('corporateSuggested');
                        scheduleSuggestionsMapped = this.maintenanceForm.get('scheduleSuggestions').value.map(function (scheduleSuggestion) {
                            var date = moment.utc(scheduleSuggestion.date).format('YYYY-MM-DD');
                            return { date: date, time: scheduleSuggestion.time };
                        });
                        return [4 /*yield*/, this.maintenancesApi.updateMaintenanceScheduleSuggestions(this.maintenance.id, scheduleSuggestionsMapped).toPromise()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.maintenancesApi.update(this.maintenance.id, maintenance).toPromise()];
                    case 4:
                        _a.sent();
                        this.refreshDatatable = true;
                        this.matDialogRef.close();
                        this.customMessageService.success('MAINTENANCES.MAINTENANCE_SUCCESSFULLY_SAVED_MESSAGE');
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        this.customMessageService.error('MAINTENANCES.ERRORS.INVALID_MAINTENANCE');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.isSavingMaintenance = false;
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogEditMaintenanceComponent.prototype.wasUpdatedLabels = function (event) {
        this.refreshDatatable = event;
    };
    DialogEditMaintenanceComponent.prototype.openRelocationDialog = function () {
        var _this = this;
        if (!this.maintenance.company) {
            this.customMessageService.error('MAINTENANCES.MAINTENANCE_REALLOCATE_WITHOUT_COMPANY');
            return;
        }
        var reallocateMaintenanceDialog = this.matDialog.open(DialogReallocateMaintenanceComponent, {
            panelClass: 'dialog-reallocate-maintenance',
            data: this.maintenance,
            hasBackdrop: false
        });
        reallocateMaintenanceDialog.afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.refreshDatatable = true;
                _this.matDialogRef.close(true);
            }
        });
    };
    DialogEditMaintenanceComponent.prototype.archiveMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alertDialog, archived;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alertDialog = this.matDialog.open(DialogAlertComponent, {
                            panelClass: 'dialog-alert'
                        });
                        return [4 /*yield*/, alertDialog.afterClosed().toPromise()];
                    case 1:
                        archived = _a.sent();
                        if (!archived) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.maintenancesApi.archiveMaintenance(this.maintenance.id)];
                    case 2:
                        _a.sent();
                        this.refreshDatatable = true;
                        this.matDialogRef.close(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogEditMaintenanceComponent.prototype.unarchiveMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.maintenancesApi.unarchiveMaintenance(this.maintenance.id)];
                    case 1:
                        _a.sent();
                        this.refreshDatatable = true;
                        this.matDialogRef.close(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogEditMaintenanceComponent.prototype.openCancelDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.confirmDialogService.open({
                            title: this.translateService.instant('MAINTENANCES.ALERT.CANCEL.TITLE'),
                            message: this.translateService.instant('MAINTENANCES.ALERT.CANCEL.MESSAGE'),
                            okText: this.translateService.instant('MAINTENANCES.ALERT.CANCEL.OK_TEXT'),
                            cancelText: this.translateService.instant('MAINTENANCES.ALERT.CANCEL.CANCEL_TEXT'),
                            inputLabel: this.translateService.instant('MAINTENANCES.ALERT.CANCEL.CANCELATION_REASON_LABEL'),
                            inputRequired: true
                        })];
                    case 1:
                        result = _a.sent();
                        if (!result || !result.confirmed) {
                            return [2 /*return*/];
                        }
                        this.fuseProgressBarService.show();
                        this.isSavingMaintenance = true;
                        return [4 /*yield*/, this.maintenancesApi.cancelMaintenance({
                                id: this.maintenance.id,
                                cancellationReason: result.message
                            })];
                    case 2:
                        _a.sent();
                        this.fuseProgressBarService.hide();
                        this.refreshDatatable = true;
                        this.isSavingMaintenance = false;
                        this.matDialogRef.close(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogEditMaintenanceComponent.prototype.openReopenDialog = function () {
        var _this = this;
        this.matDialog.open(DialogReopenMaintenanceComponent, {
            panelClass: 'field-dialog-860',
            hasBackdrop: false,
            data: {
                isViewMode: this.isViewMode,
                maintenance: this.maintenance
            },
        }).afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.refreshDatatable = true;
                _this.matDialogRef.close(true);
            }
        });
    };
    DialogEditMaintenanceComponent.prototype.onSelectedTabChange = function (event) {
        var commentTabIndex = this.tabIndex.comment;
        if (event.index === commentTabIndex) {
            this.tabComments.scrollToBottom();
        }
    };
    return DialogEditMaintenanceComponent;
}());
export { DialogEditMaintenanceComponent };
